import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const concentration: BlogMetaData = {
  title: '子どもの集中力とは？モンテッソーリ「集中現象」に学ぶ伸ばし方',
  description:
    '子どもの集中力はなぜ続かない？モンテッソーリの「集中現象」から、分数で比べない見方、集中を中断しにくい声かけと環境の整え方、気になる時の相談先を解説します。',
  thumbnailUrl: '/img/blog-concentration.webp',
  filePath: buildBlogFilePath('concentration'),
  category: BLOG_CATEGORY.INTRODUCTION,
};
